module.exports = __webpack_public_path__ + "assets/img/tx15t.951bb61b.jpg";